import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Video, Film, GraduationCap } from 'lucide-react';
export function FilmsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-147">
      <Header data-id="element-148" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-149">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-151">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-152" />
            Back to Home
          </a>

          <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-153">
            <div className="mb-12 flex justify-center" data-id="element-154">
              <img src="https://cdn.magicpatterns.com/uploads/5psnYgvbA4E9mU4Q3CmWZP/Twice_Bourne_Ent._Logo_White-08.png" alt="Twice Bourne Entertainment Films Logo" className="max-w-md w-full h-auto" data-id="element-155" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-156">
              Twice Bourne Entertainment Films LLC
            </h1>
            <p className="text-xl text-slate-300" data-id="element-157">
              Crafting compelling narratives that captivate audiences globally.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-158">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-159">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-160">
                <Video className="w-8 h-8" data-id="element-161" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-162">
                Film Production
              </h3>
              <p className="text-slate-300" data-id="element-163">
                Producers and sellers of high-quality movies, dedicated to
                cinematic storytelling.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-164">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-165">
                <Film className="w-8 h-8" data-id="element-166" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-167">
                Film Acquisition
              </h3>
              <p className="text-slate-300" data-id="element-168">
                Buying movies from independent producers to expand our diverse
                portfolio.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-169">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-170">
                <GraduationCap className="w-8 h-8" data-id="element-171" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-172">
                Cinematic Courses
              </h3>
              <p className="text-slate-300" data-id="element-173">
                Hosting of mini courses for cinematic enthusiasts to learn the
                art of filmmaking.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-174" />
    </div>;
}